import React from "react";
import "./SearchProCard.css";

let baseImgFound = false;

function SearchProCard(props) {
  const handleCardClick = (e) => {
    if (!e.target.closest('.action-button')) {
      if (props.onCardClick) {
        props.onCardClick();
      }
    }
  };

  const handleAddClick = (e) => {
    e.stopPropagation();
    if (props.updtprofun) {
      props.updtprofun(props.lead, props.productName, getBaseImage(), null, props.price);
    }
  };

  const getBaseImage = () => {
    let imgSrc = "";
    baseImgFound = false;
    props.images.forEach((item) => {
      if (item.baseImage && !baseImgFound) {
        baseImgFound = true;
        if (item.image.startsWith("products") || item.image.startsWith("mob")) {
          imgSrc = item.image;
        } else {
          imgSrc = item.image.substr(41);
        }
      }
    });
    baseImgFound = false;
    return imgSrc;
  };

  const renderImage = () => {
    baseImgFound = false;
    let imageElement = null;

    props.images.forEach((item) => {
      if (item.baseImage && !baseImgFound) {
        baseImgFound = true;
        let imgSrc = "";

        if (item.image.startsWith("products") || item.image.startsWith("mob")) {
          imgSrc = "https://s3.toolsvilla.com/" + item.image;
        } else {
          imgSrc = "https://s3.toolsvilla.com/" + item.image.substr(41);
        }

        imageElement = (
          <div className="product-image-container">
            <img
              src={imgSrc}
              className="product-image"
              alt={props.productName}
              loading="lazy"
            />
          </div>
        );
      }
    });

    return imageElement;
  };

  const renderActionButton = () => {
    // check if it attribute product SL-1143
    const vendor = props.vendors && props.vendors[0] !== null ? props.vendors[0] : null;
    if ( vendor && (vendor.combination && vendor.combination.length > 0) ) {
      // Priority 1: All combinations already added & active
      if (props.isAllcomb || props.isAllCombReqApprov) {
        return (
          <button className="action-button btn-added" disabled>
            <i className="bi bi-check-circle-fill"></i>
            <span>Already Added</span>
          </button>
        );
      }

      // Priority 2: Combination product pending approval
      if (props.isPend || props.isAllCombReqPend) {
        return (
          <button className="action-button btn-pending" disabled>
            <i className="bi bi-clock-history"></i>
            <span>Pending Approval</span>
          </button>
        );
      }

    } else {

      // Priority 3: Non-combination product — check vendor status
      // const vendor = props.vendors && props.vendors[0] !== null ? props.vendors[0] : null;

      if (vendor) {
        // Fully approved and active
        if (vendor.vActive === "ACTIVE") {
          return (
            <button className="action-button btn-added" disabled>
              <i className="bi bi-check-circle-fill"></i>
              <span>Already Added</span>
            </button>
          );
        }

        // Has price or combination set but not yet ACTIVE = pending approval
        // if (
        //   vendor.purchase_price ||
        //   (vendor.combination && vendor.combination.length > 0)
        // ) 
        if (
          vendor.purchase_price && vendor.vActive !== "ACTIVE"
        ){
          return (
            <button className="action-button btn-pending" disabled>
              <i className="bi bi-clock-history"></i>
              <span>Pending Approval</span>
            </button>
          );
        }
      }
    }

    // Priority 4: Not added yet — show Add button
    return (
      <button className="action-button btn-add pushable" onClick={handleAddClick}>
        <span className="shadow"></span>
        <span className="front">
          <i className="bi bi-plus-circle"></i>
          <span>Add</span>
        </span>
      </button>
    );
  };

  return (
    <div className="search-pro-card-wrapper">
      <div className="product-card" onClick={handleCardClick}>
        {renderImage()}

        <div className="product-details">
          {/* Row 1: Product Name */}
          <h3 className="product-title">
            {props.productName}
          </h3>

          {/* Row 2: SKU Display */}
          <div className="product-sku-display">
            SKU: <span className="sku-value-inline">{props.SKU}</span>
          </div>

          {/* Row 3: Action Button */}
          <div className="action-only-row">
            <div onClick={(e) => e.stopPropagation()}>
              {renderActionButton()}
            </div>
          </div>

          {/* Row 4: Brand */}
          {props.manufacturerName && (
            <div className="brand-row">
              <div className="brand-section">
                <span className="brand-label">Brand:</span>
                <span className="brand-name">{props.manufacturerName}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchProCard;